




import { Component, Vue } from "vue-property-decorator";

import ReportTemplatesList from "@/components/Settings/ReportTemplatesList.vue";

// Thin route view: the list is a component so it can also be mounted outside the
// Settings shell.
@Component({ components: { ReportTemplatesList } })
export default class ReportTemplates extends Vue {}
